import angular from 'angular';
import sha256 from 'js-sha256';
import sha512 from 'js-sha512';
class EvidenceValidationController {
   constructor($previousState, $state, $filter, $scope, AppConfig, EvidenceAPI, message, FileUploader) {
      "ngInject";
      this.tranlsteFilter = $filter('translate');
      this.$previousState = $previousState;
      this.$state = $state;
      const self = this
      this.EvidenceAPI = EvidenceAPI;
      this.message = message;
      this.tipsObj = {}
      this.fingerType={
         0:"SHA256",
         1:"SM3"
      }

      FileUploader.FileSelect.prototype.isEmptyAfterSelection = function () {
         return true; // true|false
      };
      this.packageUploader = new FileUploader({
         filters: [
            {
               name: 'type',
               fn: function (item) {
                  if (/\.zip/.test(item.name) || /zip/.test(item.type)) {
                     return true
                  }
                  message.error(self.tranlsteFilter('home-evidences-text055'));
                  return false
               }
            }
         ],
         onAfterAddingFile: (item) => {
            if (this.packageUploader.queue.length > 1) {
               this.packageUploader.queue[0].remove();
            }
            const fr = new FileReader();
            fr.onload = (e) => {
               this.uploader.formData = [{
                  sha256_hash: sha256(e.target.result),
                  sha512_hash: sha512(e.target.result)
               }]
            }
            fr.readAsArrayBuffer(item._file);
         }
      })

      this.uploader = new FileUploader({
         url: AppConfig.server_url + '/originals/package/verify',
         withCredentials: true,
         alias: 'package_file',
         filters: [
            {
               name: 'type',
               fn: function (item) {
                  if (/\.zip/.test(item.name) || /zip/.test(item.type)) {
                     return true
                  }
                  message.error(self.tranlsteFilter('home-evidences-text043'));
                  return false
               }
            }
         ],
         onAfterAddingFile: (item) => {
            if (this.uploader.queue.length > 1) {
               this.uploader.queue[0].remove();
            }
         },
         onSuccessItem: (item, res) => {
            
            if (res.status.code === 200) {
               // console.log(res)
               this.tipsObj = res.data
               $state.go('app.page.verify.main.evidence.success')
            } else {
               this.errorMessage = res.status.message
               $state.go('app.page.verify.main.evidence.error')
            }
            this.uploader.clearQueue();
            this.packageUploader.clearQueue();
         }
      });
   }

   // onSubmit(form) {
   //    // console.log(form)
   //    if (form.$invalid) return
   //    this.EvidenceAPI.one('evidence').post('verify', {
   //       hash: this.formData.hash,
   //       tsa_sign: this.formData.sign,
   //       tsa_time: this.formData.time
   //    }).then(res => {
   //       console.log(res)
   //       if (res.status.code === 200) {
   //          this.message.success(this.tranlsteFilter('home-evidences-text044'))
   //       } else {
   //          this.message.error(this.tranlsteFilter('home-evidences-text051'))
   //       }
   //    })
   // }

   // block_hash: "6D04A090ACF7EC70F1580BB30E265B26883ED368"
   // content_hash: "0FA3507CE0B382245B3C0EAA731DCD7654BB2A0B36EAACCD1FA623A1754AC40D"
   // created_at: "2019-11-07 19:30:29"
   // tsa_time: "2019-11-07 19:30:32"
   // yuanben_id: "34XDENB9DNX5LCV93REYZKR7A7XC73X33DSE0CLNIJS54KTSFG"
   








   submitFile() {
      this.uploader.uploadAll()
   }

   back() {
      this.$state.go('app.page.verify.main.evidence.form');
   }
}

export default EvidenceValidationController;



// WEBPACK FOOTER //
// ./src/app/components/page/verify/evidence-validation/evidence-validation.controller.js